// react-router's BrowserRouter keeps its position in history.state.idx, an undocumented field of @remix-run/router.
export const routerHistoryIndex = (state: unknown = window.history.state): number | undefined => {
  const idx = (state as { idx?: unknown } | null)?.idx;
  return typeof idx === "number" ? idx : undefined;
};
